<template>
  <div class="aaaaa">

    <div class="bbbbb">
      <!-- 头部部分 -->
      <div ref="search_d">
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-form label-width="120px" label-height="60px" class="demo-form-inline">
            <el-col :span="8">
              <el-form-item label="用户名称">
                <el-input style="width: 100%;" v-model="queryInfo.condition.memberName"
                         clearable  placeholder="用户名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户手机号">
                <el-input style="width: 100%;" v-model="queryInfo.condition.memberPhone"
                          clearable placeholder="用户手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交易类型">
                <el-select style="width: 100%;" v-model="queryInfo.condition.scoreSource" placeholder="交易类型">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="签到" value="1"></el-option>
                  <el-option label="浏览商品" value="2"></el-option>
                  <el-option label="当日首次下单" value="3"></el-option>
<!--                  <el-option label="平台赠送" value="4"></el-option>-->
<!--                  <el-option label="开通会员" value="5"></el-option>-->
<!--                  <el-option label="积分兑换" value="6"></el-option>-->
                  <el-option label="完善身份信息" value="7"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建时间">
                <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" v-model="value1" type="daterange"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" style="display: flex;justify-content: flex-end;">
              <el-form-item>
                <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
                <el-button @click="reset">重置</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>

      <!-- 表格部分 -->
      <div>
        <el-table border ref="table"  v-loading="loading" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="height">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

          <el-table-column label="用户名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
          </el-table-column>
          <el-table-column label="用户手机号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberPhone }}</template>
          </el-table-column>
          <el-table-column label="头像" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-avatar shape="square" :size="50" :src="scope.row.memberLogo"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column label="积分" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.score }}</template>
          </el-table-column>
          <el-table-column label="类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.type === 1 ? '增加' : '使用' }}</template>
          </el-table-column>
          <el-table-column label="积分来源" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ getScoreSource(scope.row.scoreSource) }}</template>
          </el-table-column>
          <el-table-column label="剩余积分" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.surplusScore }}</template>
          </el-table-column>
          <!-- <el-table-column label="关联编码" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.objectCode }}</template>
            </el-table-column> -->
          <el-table-column label="创建时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createTime }}</template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="135" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button>
              <el-popconfirm title="确定删除吗？" @onConfirm="handleDelte(scope.row.id)">
                <el-button slot="reference" type="text">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- 分页 -->
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]"
                         :page-size="queryInfo.pageSize"
                         layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="(labelType == 'add' ? '新增' : '编辑')" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">

          <el-col :span="12">
            <el-form-item label="id：" prop="siteName">
              <el-input v-model="form.id" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户编码：" prop="siteName">
              <el-input v-model="form.memberCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名称：" prop="siteName">
              <el-input v-model="form.memberName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="头像：" prop="siteName">
              <el-input v-model="form.memberLogo" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="积分：" prop="siteName">
              <el-input v-model="form.score" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型：" prop="siteName">
              <el-input v-model="form.type" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="积分来源：" prop="siteName">
              <el-input v-model="form.scoreSource" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="剩余积分：" prop="siteName">
              <el-input v-model="form.surplusScore" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联编码：" prop="siteName">
              <el-input v-model="form.objectCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间：" prop="siteName">
              <el-input v-model="form.createTime" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 236, // 表格高度
      headerHeight: 0,
      value1: [],
      loading: false
    }
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 236
    },

    // 获取数据
    getList () {
      var that = this
      this.loading = true
      // console.log(';;;l',this.value1?.[0]!=undefined,this.value1[0])
      if (this.value1?.[0] != undefined) {
        that.queryInfo.condition.startTime = this.value1[0] + ' 00:00:00'
      } else {
        that.queryInfo.condition.startTime = ''
      }
      if (this.value1?.[1] != undefined) {
        that.queryInfo.condition.endTime = this.value1[1] + ' 23:59:59'
      } else {
        that.queryInfo.condition.endTime = ''
      }
      that.$http.post('/memberScoreRecords/manageList', that.queryInfo).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.loading = false
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
        }
      })
    },

    // 保存
    handleSave () {
      var that = this
      that.$http.post('/memberScoreRecords/save', that.form).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '保存成功',
            showClose: true
          })
          that.showDialog = false
          that.search()
        } else {
          that.$notify.info({
            title: '提示',
            message: response.data.message,
            showClose: true
          })
        }
      }).catch(function (error) {

      })
    },

    // 修改
    edit (row) {
      this.showDialog = true
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },

    // 删除当前行
    //    handleDelte (id) {
    //      del({ id: id }).then(res => {
    //        if (res.code == 200) {
    //         this.$message.success('删除成功')
    //         this.getList()
    //       }
    //      })
    //    },

    // 删除用户
    async handleDelte (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/memberScoreRecords/delete', { 'id': id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.search()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },
    search () {
      this.queryInfo.currPage = 1
      this.getList()
    },
    // 新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },

    // 获取积分来源
    getScoreSource (scoreSource) {
      if (scoreSource === 1) {
        return '签到'
      } else if (scoreSource === 2) {
        return '浏览商品'
      } else if (scoreSource === 3) {
        return '当日首次下单'
      } else if (scoreSource === 4) {
        return '平台赠送'
      } else if (scoreSource === 5) {
        return '开通会员'
      } else if (scoreSource === 6) {
        return '积分兑换'
      } else if (scoreSource === 7) {
        return '完善身份信息'
      }
      return ''
    },

    reset () {
      this.queryInfo.condition = {}
      this.value1 = []
      this.search()
    }

  }
}
</script>

<style scoped></style>
